<template>
<base-nav container-classes="container-fluid" class="navbar-top navbar-expand" :class="{'navbar-dark': type === 'default'}">
    <!-- <a href="#" aria-current="page" class="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block active router-link-active"> {{$route.name}} </a> -->
    <div class="tajuk">
    <h3 class="mb-0"
    style="font-size: 50px; 
           font-weight: bold; 
           font-family: 'Montserrat', sans-serif; 
           color: #ffffff; 
           text-shadow: 6px 5px 5px rgba(0,0,0,0.5);">SISTEM SEMAKAN GAJI </h3>
    </div>
    <!-- Navbar links -->
    <b-navbar-nav class="align-items-center ml-md-auto">
        <!-- This item dont have <b-nav-item> because item have data-action/data-target on tag <a>, wich we cant add -->
        <li class="nav-item d-sm-none">
            <a class="nav-link" href="#" data-action="search-show" data-target="#navbar-search-main">
                <i class="ni ni-zoom-split-in"></i>
            </a>
        </li>
    </b-navbar-nav>
        <b-navbar-nav class="align-items-center ml-auto ml-md-0">
      <base-dropdown menu-on-right
                     class="nav-item"
                     tag="li"
                     title-tag="a"
                     title-classes="nav-link pr-0">
        <a href="#" class="nav-link pr-0" @click.prevent slot="title-container">
          <b-media no-body class="align-items-center">
                  <span class="avatar avatar-sm rounded-circle">
                    <img alt="Image placeholder" src="img/theme/team-4b.jpg">
                  </span>
            <b-media-body class="ml-2 d-none d-lg-block">
              <span class="mb-0 text-sm  font-weight-bold">{{nama}}</span>
            </b-media-body>
          </b-media>
        </a>

        <template>

          <b-dropdown-header class="noti-title">
            <h6 class="text-overflow m-0">{{peranan}}</h6>
          </b-dropdown-header>
          <b-dropdown-item v-if="false" href="#!">
            <i class="ni ni-single-02"></i>
            <span>My profile</span>
          </b-dropdown-item>
          <b-dropdown-item v-if="false" href="#!">
            <i class="ni ni-settings-gear-65"></i>
            <span>Settings</span>
          </b-dropdown-item>
          <b-dropdown-item v-if="false" href="#!">
            <i class="ni ni-calendar-grid-58"></i>
            <span>Activity</span>
          </b-dropdown-item>
          <b-dropdown-item v-if="false" href="#!">
            <i class="ni ni-support-16"></i>
            <span>Support</span>
          </b-dropdown-item>
          <div class="dropdown-divider"></div>
          <b-dropdown-item-button @click="logout">
            <i class="ni ni-user-run"></i>
            <span>Logout</span>
          </b-dropdown-item-button>

        </template>
      </base-dropdown>
    </b-navbar-nav>
</base-nav>
</template>

<script>
import {
    CollapseTransition
} from 'vue2-transitions';
import {
    BaseNav,
    Modal
} from '@/components';
import PenggunaService from '@/services/PenggunaService.js';

export default {
    components: {
        CollapseTransition,
        BaseNav,
        Modal
    },
    props: {
        type: {
            type: String,
            default: 'default', // default|light
            description: 'Look of the dashboard navbar. Default (Green) or light (gray)'
        }
    },
    computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    nama(){
      return this.$store.state.Pengguna.name
    },
    peranan(){
      const roleId=this.$store.state.Pengguna.roleID
      return PenggunaService.getPeranan(roleId)
    }
  },
    data() {
        return {
            activeNotifications: false,
            showMenu: false,
            searchModalVisible: false,
            searchQuery: ''
        };
    },
    methods: {
        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        toggleNotificationDropDown() {
            this.activeNotifications = !this.activeNotifications;
        },
        closeDropDown() {
            this.activeNotifications = false;
        },
        logout(){
      //alert('logout')
      PenggunaService.ev_logout().then(()=>{
        console.log('Logout for active session successfull')
      }).then(()=>{
        this.$store.commit('logout')
        this.$router.push('/login')
      })
      
    }
    }
};
</script>
<style>
/* .navbar-light .navbar-nav .active > .nav-link{
  color:brown;
} */

.navbar-light .navbar-nav .nav-link{
  color:rgb(233, 241, 237);
}

.navbar-light .navbar-nav .nav-link.active{
  color:rgb(58, 238, 148);
}

.tajuk h3 {
  font-weight: bold; /* Jadikan teks bold */
  color: #ffffff; /* Warna teks putih */
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5); /* Bayang pada teks */
  font-size: 1.5rem; /* Saiz teks */
  text-align: center; /* Pusatkan teks */
  margin: 20px 0; /* Ruang di atas dan bawah */
}
</style>
